import React, { useContext } from 'react';
import { LocaleContext } from './LocaleContext';
import type { IResource } from './resource';
import { res } from './resource';

export const useResource = () => {
  const { locale, setLocale } = useContext(LocaleContext);
  return React.useMemo(
    () => ({
      locale,
      setLocale,
      r: res(locale) as (
        resources: IResource,
        count?: number | undefined,
      ) => string,
    }),
    [locale, setLocale],
  );
};
